import GooglePlacesSchoolSearch from './google_places_school_search'

class Sofatutor.Classes.SchoolAccountRequest
  constructor: ->
    new GooglePlacesSchoolSearch('school_account_request') unless Sofatutor.env == 'test'

    @$addSchoolPopupCloseButton = $('.js-close-add-school-popup')
    @$schoolInformationInputs   = $('#school_account_request_country, #school_account_request_federal_state, #school_account_request_city, #school_account_request_zip_code, #school_account_request_organization')
    @$addSchoolPopup            = $('#teacher-account-request-add-school-popup')
    @$schoolSearchField         = $('#js-google-search-field')

    new Foundation.Reveal(@$addSchoolPopup)

    @bindEvents()
    @setSearchFieldValue()

  bindEvents: =>
    @$schoolInformationInputs.on 'change blur focusout keyup', =>
      if (Array.from(@$schoolInformationInputs).filter (input) -> input.value != '').length == 5
        @$addSchoolPopupCloseButton.prop('disabled', false)
      else
        @$addSchoolPopupCloseButton.prop('disabled', true)
    @$addSchoolPopup.on 'closed.zf.reveal', @setSearchFieldValue

  setSearchFieldValue: =>
    @$schoolSearchField.val($('#school_account_request_organization').val())

$ ->
  return unless $('.school-account-request, .teacher-offers-request, .js-startchancen-form')[0]
  new Sofatutor.Classes.SchoolAccountRequest
